let getQuestionScore = (question, $ansText) => {
  const FILL_IN_THE_BLANK = 1
  const questionId = question.questionId
  const $quesType = question.questionType
  const $quesScoreInDb = question.scoreValue

  let $answers = question.answers
  let $correctAns = []
  let $isCorrect = 0
  let $totalScore = 0
  let $inputAnsArr = []
  let examAnswerData = []

  // to avoid  variable never used error
  $totalScore = $isCorrect

  if ($quesType === 0 || $quesType === 2) { // TF,MC
    // $inputAnsArr is array because earlier we had MC option
    $inputAnsArr.push($ansText)
    // console.log('$inputAnsArr', $inputAnsArr)
    // console.log('$inputAnsArr', $ansText)
    $ansText = null
    let $availCorrectCount = 0
    let $availIncorrectCount = 0
    $answers.forEach($ans => {
      if ($ans.is_correct === 0 || $ans.is_correct === true) { // IN DB 0=>CORRECT , 1=>INCORRECT
        $correctAns.push($ans.answer_id)
        $availCorrectCount++
      } else {
        $availIncorrectCount++
      }
      if ($inputAnsArr.includes(parseInt($ans.answer_id))) {
        examAnswerData.push({answerId: parseInt($ans.answer_id), userEntry: true})
      } else {
        examAnswerData.push({answerId: parseInt($ans.answer_id), userEntry: false})
        $inputIncorrectCount++
      }
    })
    if ($inputAnsArr.length !== $correctAns.length) {
      $isCorrect = 0
    } else {
      $isCorrect = 1
      $inputAnsArr.forEach($ipa => {
        if ($correctAns.includes(parseInt($ipa))) {
          $isCorrect = 0
        }
      })
    }

    // to get correct/incorrect input count
    let $inputCorrectCount = 0
    let $inputIncorrectCount = 0

    // console.log('$correctAns', $correctAns)
    $inputAnsArr.forEach(($ipa) => {
      // console.log('$ipa', $ipa)
      if ($correctAns.includes(parseInt($ipa))) {
        $inputCorrectCount++
      } else {
        $inputIncorrectCount++
      }
    })
    $availCorrectCount = $availCorrectCount === 0 ? 1 : $availCorrectCount
    $availIncorrectCount = $availIncorrectCount === 0 ? 1 : $availIncorrectCount

    // console.log('$isCorrect', $isCorrect)

    $totalScore = ($quesScoreInDb * ($inputCorrectCount / $availCorrectCount)) - ($quesScoreInDb * ($inputIncorrectCount / $availIncorrectCount))
    if ($totalScore <= 0) {
      $totalScore = 0
    } else {
      $totalScore = Math.floor($totalScore)
    }
  } else if ($quesType === FILL_IN_THE_BLANK) {
    examAnswerData = null
    $ansText = $ansText.toLowerCase()
    $answers.forEach($ans => {
      if ($ans.is_correct === 0) { // IN DB 0=>CORRECT , 1=>INCORRECT
        $correctAns.push($ans.text.toLowerCase())
      }
    })

    if ($correctAns.includes($ansText)) {
      $isCorrect = 1
      $totalScore = $quesScoreInDb
    } else {
      $isCorrect = 0
      $totalScore = 0
    }
  }

  return {
    memberAnswers: $inputAnsArr,
    questionId: questionId,
    responseText: $ansText,
    scoredValue: $totalScore,
    examAnswerData: examAnswerData
  }
}
export default getQuestionScore



// WEBPACK FOOTER //
// ./src/store/modules/get-question score.js